export default __webpack_public_path__ + "static/media/vector icon.e1e62cec.svg";